import type { PodcastSummary } from './types'
import PodcastResultCard from './PodcastResultCard'

type Props = {
  results: PodcastSummary[]
  activePodcastId?: string
  loading: boolean
  error?: string
  hasMore: boolean
  query: string
  onSelect: (id: string) => void
  onLoadMore: () => void
  onRetry: () => void
}

export default function PodcastSearchResults({
  results,
  activePodcastId,
  loading,
  error,
  hasMore,
  query,
  onSelect,
  onLoadMore,
  onRetry,
}: Props) {
  if (error) {
    return (
      <div className="podcast-search-results">
        <p className="music-player__status music-player__status--err">
          Couldn&rsquo;t reach the podcast directory. Check your connection and try again.{' '}
          <button type="button" className="podcast-link-button" onClick={onRetry}>
            Retry
          </button>
        </p>
      </div>
    )
  }

  if (!loading && results.length === 0 && query.trim().length >= 2) {
    return (
      <div className="podcast-search-results">
        <p className="podcast-empty">No podcasts match &lsquo;{query}&rsquo;. Try a different search.</p>
      </div>
    )
  }

  if (!loading && results.length === 0) {
    return (
      <div className="podcast-search-results">
        <p className="podcast-empty">
          Search a podcast above to browse its episodes. You&rsquo;ll pick up to 28
          episodes to load onto your toy.
        </p>
      </div>
    )
  }

  return (
    <div className="podcast-search-results">
      <ul className="podcast-search-results__list">
        {results.map((p) => (
          <li key={p.id}>
            <PodcastResultCard
              podcast={p}
              selected={p.id === activePodcastId}
              onClick={() => onSelect(p.id)}
            />
          </li>
        ))}
      </ul>
      {loading && <p className="podcast-loading">Searching…</p>}
      {!loading && hasMore && (
        <button type="button" className="btn" onClick={onLoadMore}>
          Load more
        </button>
      )}
    </div>
  )
}
